import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import type { UUID } from '@cobliteam/common-types';

import { MaintenanceRequester } from '@cobliteam/api-lib';
import type { VehicleOdometer } from '@cobliteam/api-lib/src/__generated__/graphql';

import { Environment } from '@cobliteam/react-environments';

const env = Environment.getInstance().getEnvironment();
const maintenanceRequester = new MaintenanceRequester({
  host: env.herbieApiHost,
});

const QUERY_KEY = 'VEHICLE_ODOMETER';

const useVehicleOdometer = () => {
  const queryClient = useQueryClient();

  const getOdometer = (vehicleId: UUID) => {
    return useQuery<VehicleOdometer>({
      queryKey: [QUERY_KEY, vehicleId],
      queryFn: () => maintenanceRequester.getVehicleOdometer(vehicleId),
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    });
  };

  const postOdometer = useMutation<
    VehicleOdometer,
    unknown,
    { vehicleId: UUID; currentOdometerInKm: number; odometerDateAt: number }
  >({
    mutationFn: (variables) =>
      maintenanceRequester.createVehicleOdometer(
        variables.vehicleId,
        variables.currentOdometerInKm,
        variables.odometerDateAt
      ),
    onSuccess: (data, variables) => {
      queryClient.setQueryData([QUERY_KEY, variables.vehicleId], data);
    },
  });

  return {
    getOdometer,
    postOdometer,
  };
};

export default useVehicleOdometer;
